import { isDefined } from '@aloft/toolkit-shared';

import { selectCostMultiplier } from '../../../redux/features/selectors/orderSelectors.ts';
import {
  selectOrderHasExternalDepreciation,
  selectOrderHasFunctionalDepreciation,
} from '../../../redux/features/selectors/selectOrderDepreciation.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { getCommentarySectionText } from '../utils.ts';
import { AdditionalStructures } from './AdditionalStructures.tsx';
import { Condition } from './Condition.tsx';
import { ExternalDepreciation } from './ExternalDepreciation.tsx';
import { FunctionalDepreciation } from './FunctionalDepreciation.tsx';
import { MainDwelling } from './MainDwelling.tsx';
import { Quality } from './Quality.tsx';

export const DepreciatedCost = () => {
  const hasExternalDepreciation = useAppSelector(selectOrderHasExternalDepreciation);
  const hasFunctionalDepreciation = useAppSelector(selectOrderHasFunctionalDepreciation);
  const costMultiplier = useAppSelector(selectCostMultiplier);

  const commentaryText = isDefined(costMultiplier)
    ? getCommentarySectionText('dep-cost-with-multiplier', {
        subtitleReplacements: { costMultiplier: costMultiplier.toString() },
      })
    : getCommentarySectionText('dep-cost');

  return (
    <CommentarySection {...commentaryText}>
      <MainDwelling />
      <Quality />
      <Condition />
      {hasFunctionalDepreciation && <FunctionalDepreciation />}
      {hasExternalDepreciation && <ExternalDepreciation />}
      <AdditionalStructures />
    </CommentarySection>
  );
};
